import { lccstore, userstore } from 'lcc-state';

export const formValueMap: { [key: string]: string } = {
	product_title: ``,
	product: `${window.hcstatic.product}`,
	user_email: ``,
	user_fullname: ``,
	user_id: ``,
	user_language: `${window.hcstatic.portal_language}`,
	user_name: ``
};

export const a11yMap: { [key: string]: string } = {
	name: 'name',
	email: 'email',
	'e-mail': 'email'
};

const get_product = () => {
	const { get, path } = lccstore;
	formValueMap.product_title = get(path('staticprops', 'productname'));
};

const get_user = () => {
	const { get, path } = userstore;
	formValueMap.user_name = formValueMap.user_id = get(path('user_id'));
	formValueMap.user_fullname = get(path('fullname'));
	formValueMap.user_email = get(path('email'));
	if (!formValueMap.user_email || formValueMap.user_email.indexOf('@') === -1) {
		formValueMap.user_email = '';
	}
};

export const init_valueMap = (): void => {
	if (formValueMap.user_id.length === 0) {
		get_user();
		get_product();
	}
};
